import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  // Should be the same height as navigation buttons
  padding: 16px;
`;

export const Circle = styled.div`
  border-radius: 50%;
  background: ${props => (props.selected ? "#5d69e6" : "#a1a2a5")};
  width: 4px;
  height: 4px;

  :not(:last-child) {
    margin-right: 10px;
  }
`;
